var $ = require('jquery');
/**
 *  <div
 *  	data-esp-trigger-event		= hover | click
 *  	data-esp-class-name			= string = třída, která bude přenesena na ajaxem nahraný popup (jak na fixed, tak na floating)
 *  	data-esp-content-type		= html (předgenerovaný div v HTML)
 *  								= ajax (url načítaného obsahu ajaxem - poprvé, poté cache)
 *  								= ajaxScript (url ajaxem načítaného obsahu - provádí se vždy - vhodné pro formuláře, kde se očekává zpracování javascriptu + různé hodnoty CSRF tokenů)
 *  	data-esp-type 				= floating | fixed = zatím pouze pro content-type = ajax | ajaxScript, u zobrazování vygenerovaného HTML nepředpokládáme přesun na jiné místo, okno respektuje nastavení ze stylů
 *  	data-esp-target				= v případě content-type = html - jde o selector, který bude odkryt / zakryt
 *  								= v případě content-type = ajax - jde o URL, ze které budou načtena data a response bude vykreslena v cílové html vrstvě
 *  								= v případě content-type = ajaxScript - jde o URL, ze které budou načtena data a response bude vykreslena v cílové html vrstvě s tím, že budou nahrány a zpracovány i javascripty
 *  />
 */

var DEFAULTS = {
	fixedPopupContainer: '<div class="esp-fixed-container"></div>',
	fixedPopup: (customClass) => '<div class="esp-target esp-target-opened esp-fixed-target' + (customClass && customClass != '' ? ' ' + customClass : '') + '"></div>',
	floatingPopup: (customClass) => '<div class="esp-target esp-floating-target' + (customClass && customClass != '' ? ' ' + customClass : '') + '"></div>',
	activeTriggerClass: 'esp-trigger-active'
};

/***
 * Popup handler
 * @param options
 * @constructor
 */
var EdeeshopPopup = function (options) {
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._initialise();
};

/**
 * Init method, starts rendering HTML and binds events
 * @private
 */
EdeeshopPopup.prototype._initialise = function(){

	this.floatingPopupCloseTimeout = null;
	this.openedHtmlPopup = null;


	/**
	 * příprava kontejneru, do kterého budou nahrávány fixed (fullscreen) popup okna
	 */
	this._renderFixedContainer();

	/**
	 * bind eventů mouseenter a click (+ mouse leave)
	 */
	this._bindEvents();
};

EdeeshopPopup.prototype._renderFixedContainer = function() {
	this.fixedContainer = $(this.options.fixedPopupContainer).appendTo($('body'));
};

/**
 * nabinduje na vhodné odkazy (cokoliv) eventy
 * 	- mouseenter - otevření popup okna
 * 	- mouseleave - spuštení timeoutu pro zavření popup okna
 * 	- click - otevření popup okna
 * @private
 */
EdeeshopPopup.prototype._bindEvents = function() {
	var _self = this;

	$('body')
		/**
		 * bind těch odkazů, které mají data-esp-trigger-event === hover
		 */
		.on('mouseenter.esp', '.js_esp-trigger[data-esp-trigger-event="hover"]', function(event) {
			var settings = _self._getPopupSettingsData($(event.currentTarget));

			if (settings.contentType == 'html' && settings.targetLayer) {
				// nejprve odstraň jakýkoliv otevřený floating popup
				_self._removeFloatingPopup();
			}

			if (settings.contentType == 'ajax' || settings.contentType == 'ajaxScript') {
				// nejprve odstraň jakýkoliv otevřený html div
				_self._hideHtmlPopup();
			}

			_self._handleEnterEvent(event.currentTarget, 'hover');

		})
		.on('mouseleave.esp', '.js_esp-trigger[data-esp-trigger-event="hover"]', function(event) {
			var settings = _self._getPopupSettingsData($(event.currentTarget));

			_self.floatingPopupCloseTimeout = setTimeout(function() {
				if (settings.contentType == 'html' && settings.targetLayer) {
					_self._hideHtmlPopup();
				}

				if (settings.contentType == 'ajax' || settings.contentType == 'ajaxScript') {
					_self._removeFloatingPopup();
				}
			}, 200);

		})
		/**
		 * bind těch odkazů, které mají data-esp-trigger-event === click
		 */
		.on('click.esp', '.js_esp-trigger[data-esp-trigger-event="click"]', function(event) {
			event.preventDefault();
			_self._handleEnterEvent(event.currentTarget, 'click');
		});
};

/**
 * zpracování samotné akce pro otevření popup okna
 * @param trigger - odkaz / div / cokoliv, co spouští otevření popup okna
 * @param eventType - typ eventu - hover / click
 * @private
 */
EdeeshopPopup.prototype._handleEnterEvent = function(trigger, eventType) {
	var $trigger = $(trigger);
	var settings = this._getPopupSettingsData($trigger);
	var _self = this;

	// clear timeoutu v případě, že najedeme na trigger v době, kdy už běží zavření okna (aby se nezavřelo hned po novém otevření)
	clearTimeout(this.floatingPopupCloseTimeout);

	/**
	 * otevření a zavření předem vyrenderované vrstvy
	 */
	if (settings.contentType == 'html' && settings.targetLayer) {

		// ukázat vrstvu
		$(settings.targetLayer).addClass('esp-target-opened');
		this.openedHtmlPopup = $(settings.targetLayer);
		this._setActiveTriggerUnique($trigger);

		if (eventType === 'hover') {
			$(settings.targetLayer)
				// na mouseover zrušit zavření z mouseleave triggeru
				.on('mouseenter.esp', function() {
					clearTimeout(_self.floatingPopupCloseTimeout);
				})

				// a na mouseleave ji teprve zrušit
				.on('mouseleave.esp', function() {
					_self.floatingPopupCloseTimeout = setTimeout(function() {
						_self._hideHtmlPopup();
					}, 200);
				});
		}
	}

	/**
	 * nahrávání ajaxu pomocí jQuery.load kvůli zpracování javascriptu
	 */
	if (settings.contentType == 'ajaxScript' && settings.dataUrl) {

		if (settings.type == 'fixed') {
			this._renderFixedPopupAndLoadDynamicData(settings.dataUrl, settings.className);
		} else if (settings.type == 'floating') {
			this._renderFloatingPopupAndLoadDynamicData(settings.dataUrl, $trigger, settings.className, eventType);
		}
	}

	/**
	 * nahravání ajaxu klasickým GETem
	 * kešování obsahu do data-esp-html-content atributu
	 * při znovuvyvolání použít nakešovaná data
	 */
	if (settings.contentType == 'ajax' && settings.dataUrl) {

		// data z ajaxu nejsou zatím naloadována
		if ($trigger.data('espLoaded') !== '1') {

			$.ajax({
				url: settings.dataUrl,
				cache: false,
				method: 'GET'
			}).done(function( data ) {
				// uložení už jednou načtených dat
				$trigger.data('espHtmlContent', data).data('espLoaded', '1');

				if (settings.type === 'fixed') {
					// vytvoření popup okna
					_self._renderFixedPopupWithData(data, settings.className);

				} else if (settings.type == 'floating') {
					_self._renderFloatingPopupWithData(data, $trigger, settings.className, eventType);
				}
			});
		}
		// a tady už jsou, stačí je použít
		else {

			if (settings.type === 'fixed') {
				// vytvoření popup okna
				_self._renderFixedPopupWithData($trigger.data('espHtmlContent'), settings.className);

			} else if (settings.type == 'floating') {
				_self._renderFloatingPopupWithData($trigger.data('espHtmlContent'), $trigger, settings.className, eventType);
			}
		}

	}
};


/**
 * přečte data z dodaného triggeru
 * @private
 */
EdeeshopPopup.prototype._getPopupSettingsData = function($trigger) {
	var triggerSettings = {};
	triggerSettings['contentType'] = $trigger.data('espContentType');
	triggerSettings['className'] = $trigger.data('espClassName') || '';

	if (triggerSettings['contentType'] == 'html') {
		triggerSettings['targetLayer'] = $trigger.data('espTarget');
	}
	if (triggerSettings['contentType'] == 'ajax' || triggerSettings['contentType'] == 'ajaxScript') {
		triggerSettings['dataUrl'] = $trigger.data('espTarget');
		triggerSettings['type'] = $trigger.data('espType') || 'fixed';
		triggerSettings['ajaxCache'] = $trigger.data('contentType') == 'ajax';
	}

	return triggerSettings;
};

/**
 * samotné vytvoření fixed popup okna, bez obsahu
 * @param customClass
 * @private
 */
EdeeshopPopup.prototype._prepareFixedPopup = function(customClass) {
	var _self = this;

	// vytvoř samotný popup v rámci fixed dimmingu
	this.fixedPopup = $(this.options.fixedPopup(customClass)).appendTo(this.fixedContainer);

	this._renderFixedPopupCloseButton();

	this.fixedContainer.show();
	this._makeBodyUnscrollable();

};

EdeeshopPopup.prototype._renderFixedPopupCloseButton = function() {

	var _self = this;

	// vytvoř tlačítko na zavření popupu
	this.fixedPopupCloseButton = $('<div class="esp-fixed-close"></div>').appendTo(this.fixedPopup);

	// proveď zavření popup okna
	this.fixedPopupCloseButton.on('click', function() {
		_self.fixedPopupCloseButton.off();
		_self.fixedContainer.empty().hide();
		_self._makeBodyScrollable();
	});
};


/**
 * metoda vytvoří fixed popup okno a nahraje do něj dodaný obsah
 * @param result
 * @param customClass
 * @private
 */
EdeeshopPopup.prototype._renderFixedPopupWithData = function(result, customClass) {

	// vytvoř prázdné okno
	this._prepareFixedPopup(customClass);

	// přidej obsah
	$(result).appendTo(this.fixedPopup);
};

/**
 *
 * @private
 */
EdeeshopPopup.prototype._renderFixedPopupAndLoadDynamicData = function(dataUrl, customClass) {
	var _self = this;

	dataUrl += (dataUrl.indexOf('?') > -1) ? '&_ts=' : '?_ts=';
	dataUrl += this._getTimestamp();

	// vytvoř prázdné okno
	this._prepareFixedPopup(customClass);

	// load content
	this.fixedPopup.addClass('esp-popup-loading');
	this.fixedPopup.load(dataUrl, function() {
		_self._renderFixedPopupCloseButton();
		_self.fixedPopup.removeClass('esp-popup-loading');
	});
};

EdeeshopPopup.prototype._renderFloatingPopupCloseButton = function() {

	var _self = this;

	// vytvoř tlačítko na zavření popupu
	this.floatingPopupCloseButton = $('<div class="esp-fixed-close"></div>').appendTo(this.floatingPopup);

	// proveď zavření popup okna
	this.floatingPopupCloseButton.on('click', function() {
		_self._removeFloatingPopup();
	});
};

EdeeshopPopup.prototype._removeFloatingPopup = function() {
	if (this.floatingPopupCloseButton instanceof $) {
		this.floatingPopupCloseButton.off();
	}

	if (this.floatingPopup instanceof $) {
		this.floatingPopup.off().remove();
		this._setAllTriggersInactive();
	}
};

EdeeshopPopup.prototype._hideHtmlPopup = function() {
	if (this.openedHtmlPopup instanceof $) {
		this.openedHtmlPopup.off('mouseenter.esp mouseleave.esp').removeClass('esp-target-opened');
		this.openedHtmlPopup = null;
		this._setAllTriggersInactive();
	}
};

EdeeshopPopup.prototype._setActiveTriggerUnique = function(trigger) {
	this._setAllTriggersInactive();
	$(trigger).addClass(this.options.activeTriggerClass);
};

EdeeshopPopup.prototype._setAllTriggersInactive = function() {
	$('.'+this.options.activeTriggerClass).removeClass(this.options.activeTriggerClass);
};


/**
 *
 * @param dataUrl
 * @param trigger
 * @param customClass
 * @param eventType
 * @private
 */
EdeeshopPopup.prototype._renderFloatingPopupAndLoadDynamicData = function(dataUrl, trigger, customClass, eventType) {
	var _self = this;

	dataUrl += (dataUrl.indexOf('?') > -1) ? '&_ts=' : '?_ts=';
	dataUrl += this._getTimestamp();

	this._renderFloatingPopup(trigger, customClass, eventType);

	// load content
	this.floatingPopup.addClass('esp-popup-loading');
	this.floatingPopup.load(dataUrl, function() {
		_self.floatingPopup.addClass('esp-target-opened');
		_self.floatingPopup.removeClass('esp-popup-loading');

		if (eventType === 'click') {
			_self._renderFloatingPopupCloseButton();
		}

		_self._setActiveTriggerUnique(trigger);
	});
};

EdeeshopPopup.prototype._renderFloatingPopupWithData = function(result, trigger, customClass, eventType) {

	this._renderFloatingPopup(trigger, customClass, eventType);
	this.floatingPopup.addClass('esp-target-opened');

	if (eventType === 'click') {
		this._renderFloatingPopupCloseButton();
	}

	// přidej obsah
	$(result).appendTo(this.floatingPopup);

	this._setActiveTriggerUnique(trigger);

};

/**
 *
 * @param trigger
 * @param customClass
 * @param eventType
 * @private
 */
EdeeshopPopup.prototype._renderFloatingPopup = function(trigger, customClass, eventType) {
	var _self = this;

	if (this.floatingPopupCloseButton instanceof $) {
		this.floatingPopupCloseButton.off().remove();
	}

	if (this.floatingPopup instanceof $) {
		this.floatingPopup.remove();
	}

	// vytvoř floatovaný popup
	this.floatingPopup = $(this.options.floatingPopup(customClass));
	trigger.after(this.floatingPopup);

	// bind close event
	if (eventType === 'hover') {
		this.floatingPopup
			.on('mouseenter.esp', function() {
				clearTimeout(_self.floatingPopupCloseTimeout);
			})

			// a na mouseleave ji teprve zrušit
			.on('mouseleave.esp', function() {
				_self.floatingPopupCloseTimeout = setTimeout(function() {
					_self._removeFloatingPopup();
				}, 200);
			});
	}
};

/**
 *
 * @private
 */
EdeeshopPopup.prototype._getTimestamp = function() {
	return new Date().getTime();
};


/**
 *
 * @private
 */
EdeeshopPopup.prototype._makeBodyUnscrollable = function() {
	var getScrollbarWidth = () => {
		var div = $('<div style="width:50px;height:50px;overflow:hidden;position:absolute;top:-200px;left:-200px;"><div style="height:100px;"></div>');
		$('body').append(div);
		var w1 = $('div', div).innerWidth();
		div.css('overflow-y', 'scroll');
		var w2 = $('div', div).innerWidth();
		$(div).remove();
		return (w1 - w2);
	};

	$('body').addClass('overflow-full').css( { 'margin-right': getScrollbarWidth() + 'px' } );

};

EdeeshopPopup.prototype._makeBodyScrollable = function() {
	$('body').removeClass('overflow-full').css( { 'margin-right': '0px' } );
};

/************************
 * public metody
 */

/**
 *  public metoda, která může být zavolána externě a vykreslí popup s výsledkem
 */
EdeeshopPopup.prototype.createPopup = function(data, customClass) {
	this._renderFixedPopupWithData(data, customClass);
};

module.exports = EdeeshopPopup;


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/edeeshop-popup/EdeeshopPopup.js